import React from "react";
import { PrimaryButton } from "./PrimaryButton";

const CLINICS = [
  {
    name: "Heliopolis",
    days: "Mondays & Thursdays",
    hours: "03:00 PM – 05:00 PM",
    mapsQuery: "Heliopolis Cairo Egypt",
  },
  {
    name: "Zamalek",
    days: "Sundays & Wednesdays",
    hours: "12:00 PM – 02:00 PM",
    mapsQuery: "Zamalek Cairo Egypt",
  },
  {
    name: "Sheikh Zayed",
    days: "Saturdays & Tuesdays",
    hours: "01:00 PM – 03:00 PM",
    mapsQuery: "Sheikh Zayed Giza Egypt",
  },
  {
    name: "New Cairo",
    days: "Saturdays & Tuesdays",
    hours: "04:00 PM – 06:00 PM",
    mapsQuery: "New Cairo Egypt",
  },
];

function mapsHref(query) {
  const q = encodeURIComponent(query);
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

function WhatsAppIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function InstagramIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

export function ContactClinics({
  consultForm,
  handleConsultChange,
  handleConsultSubmit,
  consultStatus,
  consultLoading,
}) {
  return (
    <section
      id="contact"
      className="scroll-mt-28 bg-background py-section px-6 md:px-10"
    >
      <div className="mx-auto max-w-[1200px]">
        <h2 className="font-heading text-4xl font-semibold text-primary md:text-5xl">
          Contact &amp; Clinics
        </h2>

        <div className="mt-10 border border-accent bg-primary px-6 py-8 md:flex md:items-center md:justify-between md:px-10">
          <div className="flex flex-wrap items-center gap-4">
            <a
              href="tel:+201222144609"
              className="font-heading text-2xl text-accent md:text-[32px]"
            >
              +20 122 214 4609
            </a>
            <span className="hidden text-white/50 md:inline">|</span>
            <a
              href="tel:+201206033333"
              className="font-body text-sm text-white/90 md:text-base"
            >
              +20 120 603 3333
            </a>
          </div>
          <a
            href="https://wa.me/201222144609"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-3 border border-accent bg-accent px-6 py-3 font-body text-xs font-medium uppercase tracking-[2px] text-white transition-colors duration-300 hover:bg-primary md:mt-0"
          >
            <WhatsAppIcon className="h-6 w-6" />
            WhatsApp
          </a>
        </div>

        <div className="mt-element grid gap-0 md:grid-cols-2 lg:grid-cols-4">
          {CLINICS.map((c) => (
            <div
              key={c.name}
              className="border-b border-muted bg-surface p-6"
            >
              <h3 className="font-heading text-xl text-primary">{c.name}</h3>
              <p className="mt-3 font-body text-base font-light text-ink">
                {c.days}
              </p>
              <p className="mt-1 font-body text-[13px] tracking-[1.5px] text-muted">
                {c.hours}
              </p>
              <a
                href={mapsHref(c.mapsQuery)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block font-body text-xs font-medium uppercase tracking-[2px] text-accent underline-offset-4 hover:underline"
              >
                Get Directions
              </a>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center md:justify-start">
          <a
            href="https://www.instagram.com/drkarimrafla/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-body text-xs font-medium uppercase tracking-[2px] text-accent transition-opacity hover:opacity-80"
            aria-label="Dr. Karim Rafla on Instagram"
          >
            <InstagramIcon className="h-7 w-7" />
            Instagram
          </a>
        </div>

        <div className="mt-element border border-[#E2E8F0] bg-surface p-8 md:p-10">
          <h3 className="font-heading text-2xl text-primary">
            Request a consultation
          </h3>
          <p className="mt-2 max-w-2xl font-body text-sm font-light text-muted">
            Prefer email? Send a detailed request and our team will respond
            promptly. You can also reach us instantly via WhatsApp above.
          </p>

          <form className="mt-8 space-y-6" onSubmit={handleConsultSubmit}>
            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label htmlFor="consult-name" className="sr-only">
                  Full name
                </label>
                <input
                  id="consult-name"
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={consultForm.name}
                  onChange={handleConsultChange}
                  required
                  className="w-full border border-muted bg-background px-4 py-3 font-body text-sm text-ink placeholder:text-muted focus:border-accent focus:outline-none"
                />
              </div>
              <div>
                <label htmlFor="consult-email" className="sr-only">
                  Email
                </label>
                <input
                  id="consult-email"
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={consultForm.email}
                  onChange={handleConsultChange}
                  required
                  className="w-full border border-muted bg-background px-4 py-3 font-body text-sm text-ink placeholder:text-muted focus:border-accent focus:outline-none"
                />
              </div>
            </div>
            <div>
              <label htmlFor="consult-phone" className="sr-only">
                Phone
              </label>
              <input
                id="consult-phone"
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={consultForm.phone}
                onChange={handleConsultChange}
                required
                className="w-full border border-muted bg-background px-4 py-3 font-body text-sm text-ink placeholder:text-muted focus:border-accent focus:outline-none"
              />
            </div>
            <div>
              <label htmlFor="consult-treatment" className="sr-only">
                Treatment
              </label>
              <select
                id="consult-treatment"
                name="treatment"
                value={consultForm.treatment}
                onChange={handleConsultChange}
                required
                className="w-full border border-muted bg-background px-4 py-3 font-body text-sm text-ink focus:border-accent focus:outline-none"
              >
                <option value="">Select Treatment of Interest</option>
                <option value="botox">Botox Treatments</option>
                <option value="dermal-fillers">Dermal Fillers</option>
                <option value="facial-consultation">Facial Consultation</option>
                <option value="treatment-planning">Treatment Planning</option>
                <option value="follow-up">Follow-up Care</option>
                <option value="general-consultation">General Consultation</option>
              </select>
            </div>
            <div>
              <label htmlFor="consult-message" className="sr-only">
                Message
              </label>
              <textarea
                id="consult-message"
                name="message"
                placeholder="Tell us about your goals and any questions you have..."
                rows={4}
                value={consultForm.message}
                onChange={handleConsultChange}
                className="w-full border border-muted bg-background px-4 py-3 font-body text-sm text-ink placeholder:text-muted focus:border-accent focus:outline-none"
              />
            </div>
            <PrimaryButton type="submit" disabled={consultLoading}>
              {consultLoading ? "Sending..." : "Request Consultation"}
            </PrimaryButton>
            {consultStatus && (
              <p
                className={`font-body text-sm ${
                  consultStatus.includes("sent") ? "text-green-700" : "text-red-700"
                }`}
              >
                {consultStatus}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
